import { render, staticRenderFns } from "./AccountBalanceView.vue?vue&type=template&id=4c07f1bd&scoped=true"
import script from "./AccountBalanceView.vue?vue&type=script&lang=ts"
export * from "./AccountBalanceView.vue?vue&type=script&lang=ts"
import style0 from "./AccountBalanceView.vue?vue&type=style&index=0&id=4c07f1bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c07f1bd",
  null
  
)

export default component.exports